// removed by extract-text-webpack-plugin
module.exports = {"page-Profile__main":"Sf43emqjXYcXZ8h_9tySP","page-Profile__lessons":"_1XX274S3TNA3GTdfp-8toy","page-Profile__section-heading":"-IIyKAs9zSXSI8qHFKbGA","lecture-group":"_3Msrvj5YjP81g3Jfz4-lES","lecture-item":"_1ZCpjc6wT_ZCSAr9Yjk3t3"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ProfilePage/profile-page.scss
// module id = 1771
// module chunks = 0